export type BrandKey = "teachmaster" | "sjtu-soe";

export interface BrandConfig {
  key: BrandKey;
  organizationCode: string | null;
  displayNameZh: string;
  displayNameEn: string;
  assistantNameZh: string;
  assistantNameEn: string;
  homePath: string;
  fullLogoAsset: string;
  characterAsset: string;
  browserTitle: string;
}

export const DEFAULT_BRAND: BrandConfig = {
  key: "teachmaster",
  organizationCode: null,
  displayNameZh: "TeachMaster",
  displayNameEn: "TeachMaster",
  assistantNameZh: "TeachMaster",
  assistantNameEn: "TeachMaster",
  homePath: "/",
  fullLogoAsset: "/logo_teachmaster_full.png",
  characterAsset: "/logo_character.png",
  browserTitle: "TeachMaster",
};

export const SJTU_SOE_BRAND: BrandConfig = {
  key: "sjtu-soe",
  organizationCode: "sjtu_soe",
  displayNameZh: "交小育 × TeachMaster",
  displayNameEn: "Jiaoxiaoyu × TeachMaster",
  assistantNameZh: "交小育 · TeachMaster",
  assistantNameEn: "SOE Owl · TeachMaster",
  homePath: "/education",
  fullLogoAsset: "/brands/sjtu-soe/joint-mascot.png",
  characterAsset: "/brands/sjtu-soe/joint-mascot.png",
  browserTitle: "上海交通大学教育学院 × TeachMaster",
};

export function resolveBrandConfig(organizationCode: string | null | undefined): BrandConfig {
  return organizationCode === SJTU_SOE_BRAND.organizationCode ? SJTU_SOE_BRAND : DEFAULT_BRAND;
}
